import { AfterViewInit, Component, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { AuthService } from '../../_services/auth.service';
import { AlertService } from '../../_services/alert.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, AfterViewInit {
  resetPwdForm: FormGroup;
  loading = false;
  submitted = false;
  uid: string;
  timestamp: string;
  token: string;
  isPageLoaded = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    public authService: AuthService,
    private renderer: Renderer2,
    private translate: TranslateService
  ) {
    this.route.params.subscribe(params => {
      this.uid = params['uid'];
      this.timestamp = params['timestamp'];
      this.token = params['token'];
    });

  }

  ngOnInit() {
    this.resetPwdForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6), this.validateSamePassword]],
    });
    this.renderer.addClass(document.body, 'authentication-pages');
  }

  ngAfterViewInit(): void {
    const footerElement = document.getElementsByClassName('footer');    
    Array.from(footerElement).forEach((el) => {
      this.renderer.removeClass(el, 'footer-static');
      this.renderer.addClass(el, 'fixed-bottom');
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.resetPwdForm.controls;
  }

  private validateSamePassword(control: AbstractControl): ValidationErrors | null {
    const password = control.parent?.get('password');
    const confirmPassword = control.parent?.get('confirmPassword');
    return password?.value == confirmPassword?.value ? null : { 'notSame': true };
  }

  tryReset() {
    this.submitted = true;
    this.loading = true;

    // stop here if form is invalid
    if (this.resetPwdForm.invalid) {
      this.loading = false;
      return;
    }
    const value = {
      uid: this.uid,
      timestamp: this.timestamp,
      token: this.token,
      password: this.f.password.value
    };
    this.authService.doResetPassword(value).then(
      async res => {
        this.loading = false;
        this.alertService.success(`${res.message} <a href="/login">${this.translate.instant('login.resetpassword.loginLink')}</a>`);
      },
      err => {
        this.loading = false;
        this.alertService.error(err.message);
      }
    );
  }
}
